import { render, staticRenderFns } from "./UserWishButton.vue?vue&type=template&id=a400234e&scoped=true&lang=html&"
import script from "./UserWishButton.vue?vue&type=script&lang=js&"
export * from "./UserWishButton.vue?vue&type=script&lang=js&"
import style0 from "./UserWishButton.vue?vue&type=style&index=0&id=a400234e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a400234e",
  null
  
)

export default component.exports